// src/components/helpers/ErrorSummary.js

import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Alert from "@mui/material/Alert";

function ErrorSummary({ errorSteps, steps, onNavigate }) {
  if (errorSteps.length === 0) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
      className="form-group"
    >
      <Alert severity="error" sx={{ mb: 2, fontWeight: 700 }}>
        Please fix the following errors:
      </Alert>
      <List disablePadding>
        {errorSteps.map(({ stepIndex, fields }) => (
          <ListItem
            key={stepIndex}
            disableGutters
            sx={{ mb: 1, alignItems: "flex-start", flexDirection: "column" }}
          >
            <Typography
              variant="subtitle2"
              component="div"
              color="error.main"
              sx={{ fontWeight: 600, cursor: "pointer", mb: 0.5 }}
              onClick={() => onNavigate(stepIndex)}
            >
              <Link
                component="button"
                underline="hover"
                sx={{ fontWeight: 600, color: "error.main" }}
              >
                {steps[stepIndex]?.label}
              </Link>
            </Typography>
            {Object.entries(fields).map(([field, message]) => (
              <Typography
                key={field}
                variant="body2"
                component="div"
                color="error.main"
                sx={{ pl: 2, mb: 0.5 }}
              >
                • {field}: {message}
              </Typography>
            ))}
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}

export default ErrorSummary;
